<div class="if-feed" #feedEl>

  <!-- Empty state -->
  <div *ngIf="events.length === 0" class="if-empty">
    <i class="bi bi-broadcast"></i>
    <span>Listening for incident updates…</span>
  </div>

  <!-- Feed entries, oldest first (newest at bottom) -->
  <div *ngFor="let e of events" class="if-event" [ngClass]="'if-event-' + e.severity">

    <!-- Fire detected -->
    <ng-container *ngIf="e.type === 'fire_detected'">
      <div class="if-event-meta">
        <i class="bi bi-fire"></i>
        <span class="if-incident-id">INC-{{e.incidentId}}</span>
        <span class="if-title text-truncate" [title]="e.incidentTitle">{{e.incidentTitle}}</span>
        <span class="if-ts ms-auto">{{formatTime(e.timestamp)}}</span>
      </div>
      <div class="if-body">{{e.text}}</div>
    </ng-container>

    <!-- Zoomed image captured -->
    <ng-container *ngIf="e.type === 'zoomed_image'">
      <div class="if-event-meta">
        <i class="bi bi-camera"></i>
        <span class="if-incident-id">INC-{{e.incidentId}}</span>
        <span class="if-title text-truncate" [title]="e.incidentTitle">{{e.incidentTitle}}</span>
        <span class="if-ts ms-auto">{{formatTime(e.timestamp)}}</span>
      </div>
      <div class="if-body">{{e.text}}</div>
    </ng-container>

    <!-- Coordinates updated -->
    <ng-container *ngIf="e.type === 'coordinates_updated'">
      <div class="if-event-meta">
        <i class="bi bi-geo-alt"></i>
        <span class="if-incident-id">INC-{{e.incidentId}}</span>
        <span class="if-title text-truncate" [title]="e.incidentTitle">{{e.incidentTitle}}</span>
        <span class="if-ts ms-auto">{{formatTime(e.timestamp)}}</span>
      </div>
      <div class="if-body">
        {{e.text}}
        <span *ngIf="e.meta?.lat != null" class="if-coords">
          ({{e.meta.lat | number:'1.4-4'}}, {{e.meta.lon | number:'1.4-4'}})
        </span>
      </div>
    </ng-container>

    <!-- Note added -->
    <ng-container *ngIf="e.type === 'note_added'">
      <div class="if-event-meta">
        <i class="bi bi-chat-left-text"></i>
        <span class="if-incident-id">INC-{{e.incidentId}}</span>
        <span class="if-title text-truncate" [title]="e.incidentTitle">{{e.incidentTitle}}</span>
        <span class="if-ts ms-auto">{{formatTime(e.timestamp)}}</span>
      </div>
      <div class="if-bubble">
        <div class="if-bubble-user" *ngIf="e.meta?.author || e.user">{{e.meta?.author || e.user}}</div>
        <div class="if-bubble-text">{{e.text}}</div>
      </div>
    </ng-container>

    <!-- Status change -->
    <ng-container *ngIf="e.type === 'status_change' || e.type === 'incident_escalated'">
      <div class="if-event-meta">
        <i class="bi"
          [ngClass]="{
            'bi-exclamation-octagon': e.severity === 'critical',
            'bi-exclamation-triangle': e.severity === 'warning',
            'bi-check-circle': e.severity === 'success',
            'bi-info-circle': e.severity === 'info'
          }"></i>
        <span class="if-incident-id">INC-{{e.incidentId}}</span>
        <span class="if-title text-truncate" [title]="e.incidentTitle">{{e.incidentTitle}}</span>
        <span class="if-ts ms-auto">{{formatTime(e.timestamp)}}</span>
      </div>
      <div class="if-body" [innerHTML]="e.text"></div>
      <div class="if-user" *ngIf="e.user">{{e.user}}</div>
    </ng-container>

    <!-- Generic / unknown message types -->
    <ng-container *ngIf="e.type === 'generic'">
      <div class="if-event-meta">
        <i class="bi bi-info-circle"></i>
        <span class="if-incident-id">INC-{{e.incidentId}}</span>
        <span class="if-title text-truncate" [title]="e.incidentTitle">{{e.incidentTitle}}</span>
        <span class="if-ts ms-auto">{{formatTime(e.timestamp)}}</span>
      </div>
      <div class="if-body">{{e.text}}</div>
    </ng-container>

  </div>
</div>
